module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("c6RIp"))).then(() => module.bundle.root('fq9X7'));